import { urlQueryStringToObj } from './urlQueryStringToObj';
import { objToStr } from './objToStr';

export const setAssetParams = (assetMediaArray, isTest, type) => {
  const videoSrcs = assetMediaArray.video && assetMediaArray.video.srcs;
  const imageSrcs = assetMediaArray.image && assetMediaArray.image.srcSet;

  if (isTest) return `${assetMediaArray.imageEnabled ? 'Image' : 'Video'} asset`;

  let newVideoSrcs = videoSrcs;
  if (type === 'video' && videoSrcs) {
    const objKeys = Object.keys(videoSrcs);
    newVideoSrcs = objKeys.reduce((acc, key) => {
      const item = { ...videoSrcs[key] };
      if (item.poster && item.poster.includes('jpg')) {
        const [slideImageSrc, slideImageSrcQueryParams] = item.poster.split('?');
        const slideImageSrcQueryParamsObj = urlQueryStringToObj(slideImageSrcQueryParams);
        slideImageSrcQueryParamsObj.preferwebp = 'true';
        const src = `${slideImageSrc}?${objToStr(slideImageSrcQueryParamsObj)}`;
        item.poster = src;
      }
      acc[key] = item;
      return acc;
    }, {});
  }

  let newImageSrcs = imageSrcs;
  if (type === 'image' && imageSrcs) {
    newImageSrcs = imageSrcs.map((imgObj) => {
      const newImgObj = { ...imgObj };
      if (newImgObj.src) {
        const [slideImageSrc, slideImageSrcQueryParams] = newImgObj.src.split('?');
        const slideImageSrcQueryParamsObj = urlQueryStringToObj(slideImageSrcQueryParams);
        slideImageSrcQueryParamsObj.preferwebp = 'true';
        const src = `${slideImageSrc}?${objToStr(slideImageSrcQueryParamsObj)}`;
        newImgObj.src = src;
      }
      return newImgObj;
    });
  }

  return {
    ...assetMediaArray,
    video: assetMediaArray.video
      ? { ...assetMediaArray.video, srcs: newVideoSrcs }
      : assetMediaArray.video,
    image: assetMediaArray.image
      ? { ...assetMediaArray.image, srcSet: newImageSrcs }
      : assetMediaArray.image,
  };
};
